// Generated by ReScript, PLEASE EDIT WITH CARE


var paddingSettingGroup_settings = [
  {
    code: "paddingLeft",
    name: "Left",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "paddingRight",
    name: "Right",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "paddingTop",
    name: "Top",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "paddingBottom",
    name: "Bottom",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }
];

var paddingSettingGroup = {
  code: "padding",
  name: "Padding",
  settings: paddingSettingGroup_settings
};

var marginSettingGroup_settings = [
  {
    code: "marginLeft",
    name: "Left",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "marginRight",
    name: "Right",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "marginTop",
    name: "Top",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "marginBottom",
    name: "Bottom",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }
];

var marginSettingGroup = {
  code: "margin",
  name: "Margin",
  settings: marginSettingGroup_settings
};

var sizingSettingGroup_settings = [
  {
    code: "width",
    name: "Width",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "height",
    name: "Height",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "minWidth",
    name: "Min Width",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "minHeight",
    name: "Min Height",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "maxWidth",
    name: "Max Width",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "maxHeight",
    name: "Max Height",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }
];

var sizingSettingGroup = {
  code: "sizing",
  name: "Sizing",
  settings: sizingSettingGroup_settings
};

var borderSettingGroup_settings = [
  {
    code: "borderWidth",
    name: "Width",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "borderTopWidth",
    name: "Width Top",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "borderRightWidth",
    name: "Width Right",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "borderBottomWidth",
    name: "Width Bottom",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "borderLeftWidth",
    name: "Width Left",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "borderColor",
    name: "Color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "borderStyle",
    name: "Border Style",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "solid",
            display: "Solid"
          },
          {
            value: "dotted",
            display: "Dotted"
          },
          {
            value: "dashed",
            display: "Dashed"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "borderRadius",
    name: "Radius",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }
];

var borderSettingGroup = {
  code: "border",
  name: "Border",
  settings: borderSettingGroup_settings
};

var layoutSettingGroup_settings = [
  {
    code: "spacing",
    name: "Spacing",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "flex",
    name: "Flex",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "flexGrow",
    name: "Flex Grow",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "orientation",
    name: "Orientation",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "horizontal",
            display: "Horizontal"
          },
          {
            value: "vertical",
            display: "Vertical"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "alignItems",
    name: "Align Items",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "flex-start",
            display: "Flex Start"
          },
          {
            value: "flex-end",
            display: "Flex End"
          },
          {
            value: "center",
            display: "Center"
          },
          {
            value: "stretch",
            display: "Stretch"
          },
          {
            value: "baseline",
            display: "Baseline"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "alignSelf",
    name: "Align Self",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "flex-start",
            display: "Flex Start"
          },
          {
            value: "flex-end",
            display: "Flex End"
          },
          {
            value: "center",
            display: "Center"
          },
          {
            value: "stretch",
            display: "Stretch"
          },
          {
            value: "baseline",
            display: "Baseline"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "justifyContent",
    name: "Justify Content",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "flex-start",
            display: "Flex Start"
          },
          {
            value: "flex-end",
            display: "Flex End"
          },
          {
            value: "center",
            display: "Center"
          },
          {
            value: "space-between",
            display: "Space Between"
          },
          {
            value: "space-around",
            display: "Space Around"
          },
          {
            value: "space-evenly",
            display: "Space Evenly"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "zIndex",
    name: "Z Index",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }
];

var layoutSettingGroup = {
  code: "layout",
  name: "Layout",
  settings: layoutSettingGroup_settings
};

var backgroundWithImageSettingGroup_settings = [
  {
    code: "backgroundColor",
    name: "Background color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "backgroundImage",
    name: "Background Image",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "backgroundImageOpacity",
    name: "Background Image Opacity",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }
];

var backgroundWithImageSettingGroup = {
  code: "containerBackground",
  name: "Background",
  settings: backgroundWithImageSettingGroup_settings
};

var backgroundSettingGroup_settings = [{
    code: "backgroundColor",
    name: "Background color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  }];

var backgroundSettingGroup = {
  code: "textBackground",
  name: "Background",
  settings: backgroundSettingGroup_settings
};

var opacitySettingGroup_settings = [{
    code: "opacity",
    name: "Opacity",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  }];

var opacitySettingGroup = {
  code: "opacity",
  name: "Opacity",
  settings: opacitySettingGroup_settings
};

var absoluteLayoutSettingGroup_settings = [
  {
    code: "top",
    name: "Top",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "bottom",
    name: "Bottom",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "left",
    name: "Left",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "right",
    name: "Right",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "position",
    name: "Position",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "relative",
            display: "Relative"
          },
          {
            value: "absolute",
            display: "Absolute"
          }
        ],
        allowEmpty: true
      }
    }
  }
];

var absoluteLayoutSettingGroup = {
  code: "absoluteLayout",
  name: "Absolute Layout",
  settings: absoluteLayoutSettingGroup_settings
};

var textSettingGroup_settings = [
  {
    code: "text",
    name: "Text",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "color",
    name: "Color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "textAlign",
    name: "Text Align",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "left",
            display: "Left"
          },
          {
            value: "justify",
            display: "Justify"
          },
          {
            value: "center",
            display: "Center"
          },
          {
            value: "right",
            display: "Right"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "fontSize",
    name: "Font Size",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "fontWeight",
    name: "Font Weight",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "100",
            display: "Thin"
          },
          {
            value: "200",
            display: "Extra Light"
          },
          {
            value: "300",
            display: "Light"
          },
          {
            value: "400",
            display: "Regular"
          },
          {
            value: "500",
            display: "Medium"
          },
          {
            value: "600",
            display: "Semi Bold"
          },
          {
            value: "700",
            display: "Bold"
          },
          {
            value: "800",
            display: "Extra Bold"
          },
          {
            value: "900",
            display: "Black"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "textDecorationLine",
    name: "Text Decoration Line",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "underline",
            display: "Underline"
          },
          {
            value: "line-through",
            display: "Line-Through"
          },
          {
            value: "underline line-through",
            display: "Underline & Line-Through"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "ellipsizeMode",
    name: "Ellipsize Mode",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "head",
            display: "Head"
          },
          {
            value: "middle",
            display: "Middle"
          },
          {
            value: "tail",
            display: "Tail"
          },
          {
            value: "clip",
            display: "Clip"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "numberOfLines",
    name: "Number Of Lines",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "selectable",
    name: "Selectable",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: true
      }
    }
  },
  {
    code: "fontFamily",
    name: "Font Family",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "textTransform",
    name: "Text Transform",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "uppercase",
            display: "UPPERCASE"
          },
          {
            value: "lowercase",
            display: "lowercase"
          },
          {
            value: "capitalize",
            display: "Capitalize"
          }
        ],
        allowEmpty: true
      }
    }
  }
];

var textSettingGroup = {
  code: "text",
  name: "Text",
  settings: textSettingGroup_settings
};

var switchSettingGroup_settings = [
  {
    code: "disabled",
    name: "Disabled",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  },
  {
    code: "thumbColor",
    name: "Slider Color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "trackColorOn",
    name: "Track Color On",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "trackColorOff",
    name: "Track Color Off",
    dataType: {
      TAG: "String",
      _0: {}
    }
  }
];

var switchSettingGroup = {
  code: "switch",
  name: "Switch",
  settings: switchSettingGroup_settings
};

var inputSettingGroup_settings = [
  {
    code: "color",
    name: "Color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "placeholder",
    name: "Placeholder",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "placeholderTextColor",
    name: "Placeholder Text Color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "color",
    name: "Color",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "textAlign",
    name: "Text Align",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "left",
            display: "Left"
          },
          {
            value: "justify",
            display: "Justify"
          },
          {
            value: "center",
            display: "Center"
          },
          {
            value: "right",
            display: "Right"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "fontSize",
    name: "Font Size",
    dataType: {
      TAG: "Float",
      _0: {}
    }
  },
  {
    code: "fontWeight",
    name: "Font Weight",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "100",
            display: "Thin"
          },
          {
            value: "200",
            display: "Extra Light"
          },
          {
            value: "300",
            display: "Light"
          },
          {
            value: "400",
            display: "Regular"
          },
          {
            value: "500",
            display: "Medium"
          },
          {
            value: "600",
            display: "Semi Bold"
          },
          {
            value: "700",
            display: "Bold"
          },
          {
            value: "800",
            display: "Extra Bold"
          },
          {
            value: "900",
            display: "Black"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "textDecorationLine",
    name: "Text Decoration Line",
    dataType: {
      TAG: "Enum",
      _0: {
        values: [
          {
            value: "underline",
            display: "Underline"
          },
          {
            value: "line-through",
            display: "Line-Through"
          },
          {
            value: "underline line-through",
            display: "Underline & Line-Through"
          }
        ],
        allowEmpty: true
      }
    }
  },
  {
    code: "multiline",
    name: "Multiline",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  },
  {
    code: "fontFamily",
    name: "Font Family",
    dataType: {
      TAG: "String",
      _0: {}
    }
  }
];

var inputSettingGroup = {
  code: "input",
  name: "Input",
  settings: inputSettingGroup_settings
};

var accessibilitySettingGroup_settings = [
  {
    code: "accessible",
    name: "Accessible",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: true
      }
    }
  },
  {
    code: "accessibilityLabel",
    name: "Accessibility Label",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "accessibilityHint",
    name: "Accessibility Hint",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "accessibilityRole",
    name: "Accessibility Role",
    dataType: {
      TAG: "String",
      _0: {}
    }
  },
  {
    code: "accessibilityStateBusy",
    name: "Accessibility State Busy",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  },
  {
    code: "accessibilityStateChecked",
    name: "Accessibility State Checked",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  },
  {
    code: "accessibilityStateDisabled",
    name: "Accessibility State Disabled",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  },
  {
    code: "accessibilityStateExpanded",
    name: "Accessibility State Expanded",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  },
  {
    code: "accessibilityStateSelected",
    name: "Accessibility State Selected",
    dataType: {
      TAG: "Bool",
      _0: {
        defaultValue: false
      }
    }
  }
];

var accessibilitySettingGroup = {
  code: "accessibility",
  name: "Accessibility",
  settings: accessibilitySettingGroup_settings
};

export {
  paddingSettingGroup ,
  marginSettingGroup ,
  sizingSettingGroup ,
  borderSettingGroup ,
  layoutSettingGroup ,
  backgroundWithImageSettingGroup ,
  backgroundSettingGroup ,
  opacitySettingGroup ,
  absoluteLayoutSettingGroup ,
  textSettingGroup ,
  switchSettingGroup ,
  inputSettingGroup ,
  accessibilitySettingGroup ,
}
/* No side effect */
